import { render } from "./detail-reject-popup.vue?vue&type=template&id=617d86a6&scoped=true&ts=true"
import script from "./detail-reject-popup.vue?vue&type=script&lang=ts"
export * from "./detail-reject-popup.vue?vue&type=script&lang=ts"

import "./detail-reject-popup.vue?vue&type=style&index=0&id=617d86a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617d86a6"]])

export default __exports__